import React, { useState, useEffect } from "react";

import {
  IconButton,
  Typography,
  Menu as MenuComponent,
  MenuItem,
  Fade,
} from "@mui/material";

import { makeStyles } from "@mui/styles";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import Settings from "@mui/icons-material/Settings";

import * as actions from "../../redux/actions/index";

const useStyles = makeStyles({
  iconBtn: {
    borderRadius: "10px",
    color: "#000",
  },
});

const menuHeaders = (
  pathname,
  customerName = "",
  customer = "",
  uploadDate
) => {
  let headers = {};
  const transactionNumber = pathname.replace("/transactions/", "");
  const transactionDateFormatted = uploadDate
    ? format(new Date(uploadDate), "MM/dd/yyyy HH:mm")
    : null;
  if (pathname.indexOf("/dashboard") === 0) {
    return (headers = {
      title: "Dashboard",
      subtitle: "Data Summary and Analytics of NutriAsia",
    });
  } else if (pathname.indexOf("/transactions/") === 0) {
    return (headers = {
      title: "Transactions View",
      subtitle: `Receipt Transaction Summary #${transactionNumber} - ${customerName} - UPLOADED ON: ${transactionDateFormatted}`,
    });
  } else if (pathname.indexOf("/customers/") === 0) {
    return (headers = {
      title: `${customer.name ? customer.name : ""}`,
      subtitle: `Customer Data Summary`,
    });
  } else if (pathname.indexOf("/winners") === 0) {
    return (headers = {
      title: "Raffle Winners",
      subtitle: "NutriAsia Winners",
    });
  } else if (pathname.indexOf("/raffle") === 0) {
    return (headers = {
      title: "Raffle",
      subtitle: "NutriAsia Receipt Entry Raffle Promo",
    });
  } else if (pathname.indexOf("/transactions") === 0) {
    return (headers = {
      title: "Transactions",
      subtitle: "NutriAsia Receipt Scanning Transactions List",
    });
  } else if (pathname.indexOf("/customers") === 0) {
    return (headers = {
      title: "Customers",
      subtitle: "NutriAsia Promo Registered Users",
    });
  } else if (pathname.indexOf("/redemptions") === 0) {
    return (headers = {
      title: "Redemptions",
      subtitle: "NutriAsia Redemptions List",
    });
  } else if (pathname.indexOf("/ads") === 0) {
    return (headers = {
      title: "Ad/Link Clicks",
      subtitle: "Origin of User clicks",
    });
  } else {
    return headers;
  }
};

const Menu = ({ location, auth }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [headers, setHeaders] = useState({});
  const transaction = useSelector((state) => state.cmsTransactions.transaction);
  const customer = useSelector((state) => state.cmsCustomers.customer);
  const [menuOpen, setMenuOpen] = useState(null);

  const anchorMenuToElement = (event) => {
    setMenuOpen(event.currentTarget);
  };

  const unAnchorMenuToElement = () => {
    setMenuOpen(null);
  };

  useEffect(() => {
    let headers = menuHeaders(location.pathname);
    if (location.pathname.indexOf("/customers/") === 0 && customer) {
      headers = menuHeaders(location.pathname, null, customer[0]);
      setHeaders(headers);
    }
  }, [customer, location]);

  useEffect(() => {
    let headers = menuHeaders(location.pathname);
    setHeaders(headers);
    if (
      location.pathname.indexOf("/transactions/") === 0 &&
      transaction &&
      transaction.user
    ) {
      headers = menuHeaders(
        location.pathname,
        transaction.user.name,
        null,
        transaction.created_at
      );
      setHeaders(headers);
    }
  }, [location, transaction]);

  return (
    <div className="Menu">
      <div className="Menu__titles">
        <h3 className="heading-main m-bot-xs"> {headers.title} </h3>
        <p className="heading-subtitle"> {headers.subtitle} </p>
      </div>
      <div className="Menu__actions">
        <IconButton className={classes.iconBtn} onClick={anchorMenuToElement}>
          <Settings style={{ color: "#000", marginRight: "1rem" }} />
          <Typography>{auth.name}</Typography>
        </IconButton>
      </div>

      <MenuComponent
        id="menu-component"
        anchorEl={menuOpen}
        keepMounted
        open={Boolean(menuOpen)}
        onClose={unAnchorMenuToElement}
        TransitionComponent={Fade}
        getcontentanchorel={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MenuItem onClick={() => dispatch(actions.onAuthLogout())}>
          LOG OUT
        </MenuItem>
      </MenuComponent>
    </div>
  );
};

export default Menu;
